import { useEffect } from 'react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType, Routes, } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { environment } from 'config/environment';
import pkgJson from '../../package.json';
Sentry.init({
    // enabled: location.hostname !== 'localhost',
    environment: environment.name,
    release: pkgJson.version,
    dsn: 'https://08b7544bfc0b96772dd51bf1c1629cfc@o1253851.ingest.sentry.io/4506701452083200',
    integrations: [
        Sentry.reactRouterV6BrowserTracingIntegration({
            useEffect: useEffect,
            useLocation: useLocation,
            useNavigationType: useNavigationType,
            createRoutesFromChildren: createRoutesFromChildren,
            matchRoutes: matchRoutes,
        }),
        Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
        }),
    ],
    // Performance Monitoring
    tracesSampleRate: environment.name !== 'production' ? 1.0 : 0.1, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
        'https://api.dev.flixxo.com/api',
        'https://api.stg.flixxo.com/api',
        'https://api.pro.flixxo.com/api',
    ],
    // Session Replay
    replaysSessionSampleRate: 0.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});
export var SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);
